import { ArrowLink } from "@features/atoms/ArrowLink"
import { PageIntro } from "@features/content/PageIntro"
import { useBackground } from "@hooks/useAppState"
import { Link } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("_error", (props) => {
  useBackground({
    darken: 0.3,
    scene: "pigs",
  })

  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <PageIntro
        eyebrow={`Error ${props.statusCode}`}
        title={props.title}
        description={
          <>
            <Link className="type-label-l">
              <ArrowLink type="left">Return to the homepage</ArrowLink>
            </Link>
          </>
        }
      />
    </div>
  )
})
